// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3otQZ","content":"RecentSearches_content__gScIx"};